import { supabase } from './supabase';

export const rulebookService = {
  async getRulebook() {
    try {
      const { data, error } = await supabase
        .from('rulebook')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(1);

      if (error) {
        console.error('Supabase error:', error);
        throw error;
      }

      if (!data || data.length === 0) {
        return null;
      }

      return data[0];
    } catch (error) {
      console.error('Error fetching rulebook:', error);
      throw error;
    }
  },

  async updateRulebook(content, edition, userId, blocks = null) {
    try {
      let existingRulebook;
      try {
        existingRulebook = await this.getRulebook();
      } catch (err) {
        console.error('Error checking existing rulebook:', err);
        existingRulebook = null;
      }

      const blockData = blocks || [];

      if (existingRulebook) {
        const updatePayload = {
          content,
          edition,
          blocks: blockData,
          last_updated_by: userId,
          last_updated_at: new Date().toISOString()
        };

        const { data, error } = await supabase
          .from('rulebook')
          .update(updatePayload)
          .eq('id', existingRulebook.id)
          .select();

        if (error) {
          console.error('Update error:', error);
          throw error;
        }
        return { success: true, data };
      } else {
        const insertPayload = {
          content,
          edition,
          blocks: blockData,
          last_updated_by: userId
        };

        const { data, error } = await supabase
          .from('rulebook')
          .insert([insertPayload])
          .select();

        if (error) {
          console.error('Insert error:', error);
          throw error;
        }
        return { success: true, data };
      }
    } catch (error) {
      console.error('Error updating rulebook:', error);
      return { success: false, error: error.message };
    }
  },

  async getRulebookHistory(limit = 10) {
    try {
      const { data, error } = await supabase
        .from('rulebook')
        .select('id, edition, last_updated_at, last_updated_by')
        .order('last_updated_at', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching rulebook history:', error);
      return { success: false, error: error.message };
    }
  }
};
